import { useState } from "react";
import {
  Anchor,
  Box,
  Divider,
  NavLink,
  Paper,
  ScrollArea,
} from "@mantine/core";
import { Link } from "react-router-dom";
import { jobSeekerData } from "./sidebarData";

const JobSeekerSideBar = ({ setOpened }) => {
  const [active, setActive] = useState(0);
  const [subActive, setSubActive] = useState(0);

  const items = jobSeekerData.map((item, index) => (
    <Anchor variant="text" component={Link} to={item.path} key={index}>
      <NavLink
        variant="filled"
        color={"red.9"}
        styles={{
          root: {
            color: "white",
            ":hover": {
              color: "white",
              backgroundColor: "#FF5952",
            },
          },
          label: { fontSize: "1rem" },
        }}
        key={item.label}
        active={!item.subNav && active === index}
        label={index + 1 + " - " + item.label}
        description={item.description}
        onClick={() => {
          setActive(index);
          setSubActive(null);
          if (!item.subNav) {
          }
        }}
      >
        {item.subNav &&
          item.subNav.map((subItem, i) => (
            <Anchor
              variant="text"
              component={Link}
              to={subItem.path}
              key={subItem.label}
            >
              <NavLink
                variant="filled"
                color={"red.9"}
                styles={{
                  label: { fontSize: "1rem" },
                  root: {
                    color: "white",
                    ":hover": {
                      color: "white",
                      backgroundColor: "#FF5952",
                    },
                  },
                }}
                active={active === index && subActive === i}
                key={subItem.label}
                label={index + 1 + "." + (i + 1) + " - " + subItem.label}
                onClick={() => {
                  setSubActive(i);
                  setActive(index);
                }}
              />
            </Anchor>
          ))}
      </NavLink>
    </Anchor>
  ));

  return (
    <Paper
      w={300}
      style={{ height: "72.5vh", backgroundColor: "black", borderRadius: 0 }}
      component={ScrollArea}
    >
      <Box
        sx={{
          width: "100%",
          height: "100%",
        }}
      >
        {items}
      </Box>
    </Paper>
  );
};

export default JobSeekerSideBar;
